import React, { useEffect } from 'react';

import '../../assets/css/vega-design.css';

import VegaNavbar from '../../component/Navbar/vegaNavbar';
import VegaFooter from '../../component/Footer/vegaFooter';
import CookieModal from '../../component/cookieModal';

import VegaHero from '../../component/VegaDesign/VegaHero';
import VegaProductTrio from '../../component/VegaDesign/VegaProductTrio';
import VegaAtlas from '../../component/VegaDesign/VegaAtlas';
import VegaDeployment from '../../component/VegaDesign/VegaDeployment';
import VegaSectors from '../../component/VegaDesign/VegaSectors';
import VegaCopyBlocks from '../../component/VegaDesign/VegaCopyBlocks';
import VegaFAQ from '../../component/VegaDesign/VegaFAQ';
import VegaCTA from '../../component/VegaDesign/VegaCTA';

export default function IndexWebProgramming() {
  useEffect(() => {
    // New design is light by default; remove any previously forced dark class
    const html = document.documentElement;
    html.classList.remove('dark');
    html.classList.add('light');

    // Apply base page background via CSS variable
    document.body.style.background = 'var(--bg)';
    document.body.style.color = 'var(--ink)';
    document.body.style.fontFamily = '"Inter Tight", system-ui, sans-serif';

    return () => {
      document.body.style.background = '';
      document.body.style.color = '';
      document.body.style.fontFamily = '';
    };
  }, []);

  return (
    <div className="vd-bg-page" style={{ minHeight: '100vh' }}>
      <VegaNavbar />

      <main>
        <VegaHero copyIndex={0} />
        <VegaProductTrio />
        <VegaAtlas />
        <VegaDeployment />
        <VegaSectors />
        <VegaCopyBlocks />
        <VegaFAQ />
        <VegaCTA />
      </main>

      <VegaFooter />
      <CookieModal />
    </div>
  );
}
